import { useEffect, useState } from 'react';
import './AlcanceTotalEMensal.css';

import toast from 'react-hot-toast';

import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { BarChart, Bar } from 'recharts';

import { servGetGraficoIndicadoresMensais, servGetGraficoAlcanceTotalPeso } from '../../../servicos/graficos_indicador';

function AlcanceTotalEMensal({ dataInicio, dataFim }) {

    console.log('### Iniciando AlcanceTotalEMensal ###');

    const [countAlcanceENaoAlcance, setCountAlcanceENaoAlcance] = useState([])
    const [alcanceMensal, setAlcanceMensal] = useState([])

    // Cores pie chart
    const COLORS = ['#0088FE', '#FFB703'];

    useEffect(() => {
        getGraficoAlcanceTotal()
        getGraficoIndicadoresMensais()
    }, [dataInicio, dataFim]);

    const getGraficoAlcanceTotal = async () => {
        try {
            const countAlcanceTotalPesoDaApi = await servGetGraficoAlcanceTotalPeso(dataInicio, dataFim)
            setCountAlcanceENaoAlcance(countAlcanceTotalPesoDaApi.data)
        } catch (erro) {
            toast.error(erro.message)
            console.log(erro);
        }
    }

    const getGraficoIndicadoresMensais = async () => {
        try {
            const indicadoresMensaisDaApi = await servGetGraficoIndicadoresMensais(dataInicio, dataFim)
            setAlcanceMensal(indicadoresMensaisDaApi.data)
        } catch (erro) {
            toast.error(erro.message)
            console.log(erro);
        }
    }

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    }

    return (
        <div className='h-100 div-com-borda p-1 d-flex flex-column flex-md-row'>
            <div className='col-12 col-sm-2 text-center'>
                <p>Percentual total de alcance</p>
                <ResponsiveContainer width="100%" height="80%">
                    <PieChart >
                        <Pie
                            data={countAlcanceENaoAlcance}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={renderCustomizedLabel}
                            dataKey="value"
                        >
                            {countAlcanceENaoAlcance.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </div>
            <div className='aligm-center col-12 col-sm-10 text-center'>
                <p>Percentual mensal de alcance</p>
                <ResponsiveContainer width="100%" height="80%">
                    <BarChart
                        data={alcanceMensal}
                        margin={{
                            left: 0,
                            right: 30
                        }}
                    >
                        <XAxis dataKey="mesReferencia" />
                        <YAxis />
                        <Tooltip />
                        <Bar
                            dataKey="Alcance Mensal"
                            stackId="as"
                            fill="#0088FE"
                            label={{ fill: "white", fontSize: 15 }}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default AlcanceTotalEMensal
